export default __webpack_public_path__ + "static/media/deutz-fahr-6165-powershift.7727f3d3.jpg";